export class ContactUsModel {
  firstName: string;
  phone: string;
  email: string;
  paxes: string;
  recaptchaToken?: string;
  lastName?: string;
  subject?: string;
  message?: string;
  confirmPromotions?: boolean;
  where?: string;
  when?: string;
  pageType?: string;
  partialName?: string;
  idNumber?: string;
  orderId?: string;

  constructor(contactUsText?: string | null) {
    this.firstName = '';
    this.phone = '';
    this.email = '';
    this.paxes = '';
    this.lastName = '';
    this.subject = '1';
    this.message = contactUsText || '';
    this.partialName = '1';
    this.when = '1';
    this.where = '1';
  }
}
